import React from 'react'
import { Outlet } from 'react-router-dom'
import AuthLayout from './auth-layout'

const AuthLayoutOutlet = () => (
  <AuthLayout>
    <Outlet />
  </AuthLayout>
)

export default AuthLayoutOutlet
